import React from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import Items from '../items/Items'
import Sales from '../sales/Sales'
import Users from '../users/Users'
import Goals from '../goals/Goals'
import Discount from '../discount/Discount'


const TabsComponent = () => {
  return (
    <Tabs defaultActiveKey="items" id="uncontrolled-tab-example" className="mb-3">
        <Tab eventKey="items" title="Items">
        <Items />
      </Tab>
      <Tab className='test' eventKey="sales" title="Sales">
        <Sales />
      </Tab>
      <Tab eventKey="users" title="Users">
        <Users />
      </Tab>
      <Tab eventKey="goals" title="Goals">
        <Goals />
      </Tab>
      <Tab eventKey="discount" title="Discount">
        <Discount />
      </Tab>
      
    </Tabs>
  )
}

export default TabsComponent